import Cspm_Img from "public/cloudSecuritySase/CSPM.png";

export const TRUST_FACTORS = {
  title: "Why Security Teams Trust OneMind CSPM ",
  points: [
    {
      label: "Real-Time Posture Drift Detection",
      text: "Know the moment configurations deviate from secure baselines.",
    },
    {
      label: "AI-Driven Policy Violations Prioritization",
      text: "Focus on what matters, not every warning.",
    },
    {
      label: "Zero Infrastructure Overhead",
      text: "Agentless and API-based setup.",
    },
    {
      label: "Audit-Ready Compliance",
      text: "Reports for regulators, boardrooms, and insurers.",
    },
    {
      label: "Built for Multi-Cloud Enterprises",
      text: "Cloud-native, hybrid, or transitional — we've got you covered.",
    },
  ],
  image: Cspm_Img,
};
